import { useQuery } from 'react-query';
import { handleRequest } from '../../../../redux/services/APIService';
import storageHelper from '../../../../libs/storageHelper';
import { cacheKeys } from './cacheKeys';

export function formatAppointmentTypeTitle(title) {
  if (String(title || '').trim().toLowerCase() === 'boarding stay') {
    return 'Boarding';
  }
  return title;
}

function mapAppointmentTypeTitles(types) {
  if (!Array.isArray(types)) {
    return types;
  }
  return types.map((type) => ({
    ...type,
    title: formatAppointmentTypeTitle(type.title),
  }));
}

export const useGetAppointmentTypes = (options = {}) => {
  return useQuery(
    cacheKeys.getAppointmentTypes(options),
    async () => {
      const { user } = storageHelper.getFromStorage('loggedUser');
      const response = await handleRequest(
        'get',
        `facility/${user.facility}/appointment-types`,
        true,
        null,
        options.filter,
      );

      return mapAppointmentTypeTitles(response.data);
    },
    {
      onError: (error) => {
        console.error(
          `${error.response?.data?.data?.resultMessage || error.message}`,
        );
      },
      ...options,
    },
  );
};
